import { useNavigate } from 'react-router-dom';
import { PersonalSurvey as Questionnaire } from '@fff-web/questionnaire-component';
import PageContainer from '../shared-components/PageContainer/PageContainer';
import personalSurveyBg from './personal-survey-bg.png';
import * as styles from './PersonalSurvey.module.css';

const PersonalSurvey = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <div className={styles.header}>
        <div>
          <h1>Personal Survey</h1>
          <img className={styles.hiddenDesktop} src={personalSurveyBg} alt="" />
          <p className={styles.subheader}>
            Update your preferences to get personalized recommendations and exclusive offers!
          </p>
          <p className={styles.description}>
            While at this moment boxes aren&apos;t guaranteed to be customized according to your
            selections, your participation will help us continue to create the FabFitFun experience
            that we know you will love.
          </p>
        </div>
        <img className={styles.hiddenMobile} src={personalSurveyBg} alt="" />
      </div>
      <Questionnaire lastButtonAction={() => navigate(0)} lastPage={false} />
    </PageContainer>
  );
};

export default PersonalSurvey;
